import { useMemo } from "react";
import { documentValidationSchema } from "@/features/documents/hooks/documentValidationRules";
//import type { ExpenseDocProps } from "@/lib/types/models";
import type { Document } from "document-api-client";

export function useDocumentValidation(document: Document) {
    return useMemo(() => {
        const result = documentValidationSchema.safeParse(document);

        if (result.success) {
            return {
                isValid: true,
                fieldErrors: {}, // as Record<string, string>,
                hasErrors: false,
                //canApprove: true
            };
        }

        const fieldErrors: Record<string, string> = {};
        result.error.errors.forEach((error) => {
            const field = error.path[0] as string;
            fieldErrors[field] = error.message;
        });

        return {
            isValid: false,
            fieldErrors,
            hasErrors: true,
            //canApprove: false
        };
    }, [document]);
}
